export default "__VITE_ASSET__EFCv_jkz__"